import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import Icons from "assets";

type DragHandleCellProps = {
  rowId: string;
  tableId: string;
};

export const DragHandleCell: React.FC<DragHandleCellProps> = ({ rowId, tableId }) => {
  const { attributes, listeners, setNodeRef } = useSortable({
    id: `${tableId}-${rowId}`,
  });

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className="w-full h-full flex items-center justify-center cursor-grab active:cursor-grabbing">
      <Icons.DragDrop className="w-4 h-4 text-gray-400" />
    </div>
  );
};
